$ = jQuery;

function header() {
  $(document).ready(function () {

    // --- NEW: Search Popup Logic ---
    $('.header-search-trigger').on('click', function (e) {
      e.preventDefault();
      $('#search-modal').fadeIn(300);
      $('body').addClass('search-opened'); // За да можеш да спреш скрола през CSS
    });

    $('.close-modal, .search-overlay-bg').on('click', function () {
      $('#search-modal').fadeOut(200);
      $('body').removeClass('search-opened');
    });
    // --- End Search Logic ---

    // Mobile toggle
    $('.navbar-toggler').on('click', function () {
      $('.collapse.navbar-collapse').toggleClass('show');
      $(this).toggleClass('opened');
      $('body').toggleClass('opened-navigation');
    });

    const desktopMenu = window.matchMedia('(min-width: 992px)');

    function initDesktopHoverMenu(e) {
      $('.content-header .menu--main ul li .menu-item--expanded.dropdown-toggle').off('mouseenter mouseleave');
      $('.dropdown-menu.sub-menu').off('mouseenter mouseleave');

      if (e.matches) {
        // DESKTOP hover
        $('.content-header .menu--main ul li .menu-item--expanded.dropdown-toggle')
        .on('mouseenter', function () {
          $(this).siblings('.dropdown-menu').addClass('show');
        })
        .on('mouseleave', function () {
          $(this).siblings('.dropdown-menu').removeClass('show');
        });

        $('.dropdown-menu.sub-menu')
        .on('mouseenter', function () {
          $(this).addClass('show');
        })
        .on('mouseleave', function () {
          $(this).removeClass('show');
        });
      }
    }

    // first load
    initDesktopHoverMenu(desktopMenu);

    // on resize screen
    desktopMenu.addEventListener('change', initDesktopHoverMenu);

    $('.submenu-toggler').click(function() {
      $(this).siblings('.sub-menu').toggleClass('show');
    });

    $('.sub-menu-title').click(function() {
      $(this).parents('.dropdown-menu').toggleClass('show');
    })

    $(window).resize(function() {
      paddingTop();
    })
  });
}


window.onscroll = function() {
  stickyHeader();
};

window.onload = function() {
  paddingTop();
  stickyHeader();
}


function paddingTop() {
  if ($('.padding-height-padding').length) {
    $('.padding-height-padding').css('padding-top', $('.content-header').outerHeight() + 'px')
  }
}

function stickyHeader() {
  if (window.scrollY > 2) {
    $('.content-header').addClass("sticky");
  } else {
    $('.content-header').removeClass("sticky");
  }
}